import React, { useState } from 'react';
import './LoginScreen.css';

const LoginScreen = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // The actual password check is handled by the onLogin prop
    const loginSuccessful = onLogin(password);
    if (!loginSuccessful) {
      setError('Incorrect password, please try again.');
      setPassword('');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img 
          src="https://ambitioninnovationcreativity.com/static/media/AIC%20LOGO%20NAVBAR.68327634.svg" 
          alt="AIC Logo" 
          className="login-logo"
        />
        <h4 className="login-company-name">Ambition Innovation Creativity</h4>
        <h2 className="login-title">Prototype Access</h2>
        <p className="login-subtitle">Please enter the password to view the Nemacolin booking flow prototype.</p>
        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="login-input"
            autoFocus
          />
          {error && <p className="login-error">{error}</p>}
          <button type="submit" className="login-button">
            Continue
          </button>
        </form>
      </div>
      <div className="login-footer">
        Developed by <a href="mailto:contact@ambitioninnovationcreativity.com">Ambition Innovation Creativity</a>
      </div>
    </div>
  );
};

export default LoginScreen; 